<script>
import { groupBy } from '@utils/data/group-by'
import CVisDeviceStateHistroyDetailShiftproductivity from '@components/vis-device-state-history-detail-shift-productivity'
import DeviceStateHistoryDetailShiftHourly from '@components/vis-device-state-history-detail-shift-hourly'
import DeviceStateHistoryDetailShiftCycles from '@components/vis-device-state-history-detail-shift-cycles'
import DeviceStateHistoryDetailShiftActivities from '@components/vis-device-state-history-detail-shift-activities'

import {
  infoMethods,
  infoDetailsMethods,
  deviceProductivityMethods,
  filtersComputed,
} from '@state/helpers'

export default {
  components: {
    CVisDeviceStateHistroyDetailShiftproductivity,
    DeviceStateHistoryDetailShiftHourly,
    DeviceStateHistoryDetailShiftCycles,
    DeviceStateHistoryDetailShiftActivities,
  },

  props: {
    cachedDeviceEvents: {
      type: Array,
      default: () => [],
    },

    cachedDeviceStateAggregateHourDevice: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...filtersComputed,

    shiftPatterns: function() {
      let shiftPatterns = groupBy(
        [...this.cachedDeviceEvents].reverse(),
        (c) => c.shiftPattern.name
      )
      return shiftPatterns
    },
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
    ...deviceProductivityMethods,
  },
}
</script>

<template>
  <div>
    <b-card
      v-for="(shiftPatternDeviceEvents, name) in shiftPatterns"
      :key="name"
      :no-body="true"
      class="shiftPatternDeviceEvents"
    >
      <div slot="header">
        <span class=" text-uppercase font-weight-bold ">{{ name }} </span></div
      >

      <b-row>
        <!-- <b-col md="5">
          <CVisDeviceStateHistroyDetailShiftproductivity
            :device-events-for-shift="shiftPatternDeviceEvents"
          />
        </b-col> -->

        <b-col md="12" class="pt-3">
          <DeviceStateHistoryDetailShiftHourly
            class="mr-3 pl-1 pb-2"
            :device-aggregate-hour="cachedDeviceStateAggregateHourDevice"
            :start-hour="
              new Date(shiftPatternDeviceEvents[0].shiftPattern.start).getHours()
            "
            :end-hour="new Date(shiftPatternDeviceEvents[0].shiftPattern.end).getHours()"
          />
          <!--
          <DeviceStateHistoryDetailShiftCycles
            class="mr-3 pl-1 pb-2"
            :device-aggregate-hour="cachedDeviceStateAggregateHourDevice"
            :start-hour="
              new Date(shiftPatternDeviceEvents[0].shiftPattern.start).getHours()
            "
            :end-hour="new Date(shiftPatternDeviceEvents[0].shiftPattern.end).getHours()"
          />

          <DeviceStateHistoryDetailShiftActivities
            class="mr-3 pl-1 pb-2"
            :device-aggregate-hour="cachedDeviceStateAggregateHourDevice"
            :start-hour="
              new Date(shiftPatternDeviceEvents[0].shiftPattern.start).getHours()
            "
            :end-hour="new Date(shiftPatternDeviceEvents[0].shiftPattern.end).getHours()"
          /> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
